import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "phone", "sendButton"]
  static values = { accountEmailAvailable: Boolean }

  connect() {
    this.validate()
  }

  validate() {
    this.emailTarget.setCustomValidity("")
    this.phoneTarget.setCustomValidity("")

    const channels = Array.from(this.element.querySelectorAll('input[name="channels[]"]:checked:not(:disabled)'))
    const hasEmail = this.emailTarget.value.trim() !== "" || this.accountEmailAvailableValue
    const hasPhone = this.phoneTarget.value.trim() !== ""

    if (channels.some(channel => channel.value === "email") && !hasEmail) {
      this.emailTarget.setCustomValidity("Enter an email address before sending by email.")
    }
    if (channels.some(channel => channel.value === "sms") && !hasPhone) {
      this.phoneTarget.setCustomValidity("Enter a mobile phone number before sending a text message.")
    }

    this.sendButtonTarget.disabled = channels.length === 0 || !this.element.checkValidity()
  }

  submit(event) {
    this.validate()

    if (this.sendButtonTarget.disabled) {
      event.preventDefault()
      this.element.reportValidity()
    }
  }

}
